import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsGiftCards from "./components/SettingsGiftCards";

const SettingsGiftCardsApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <SettingsGiftCards {...props} />
  </>
);

export default SettingsGiftCardsApp;
